<template>
  <div class="table-container" ref="scroll" >
    <v-table fixed-header :height="`${customHeight}vh`" density="compact">
      <thead>
        <tr>
          <th v-for="(field,i) in fields" :key="i">
            {{ field.label }}
          </th>
          <th> </th>
        </tr>
      </thead>

      <tbody ref="table">
        <tr v-for="(item, i) in items" :key="i" 
          :class="{'highlight' : (type ==='vehicle' && item.deviceid===selectedDeviceId) || (type ==='firmwareManagement' && item.firmwareName===selectedFirmwareName)}" >
          
          <td v-for="(field,j) in fields" :key="j" >
            <div v-if="field.key==='createdAt'||field.key==='updatedAt'"> 
              {{ item[field.key] && dateFormatFunc(item[field.key]).split(' ')[0] }} <br/>{{ item[field.key] &&  dateFormatFunc(item[field.key]).split(' ')[1] }}
            </div>
            <div v-else-if="field.key==='infoDtti'"> 
              {{ dateFormatFunc(item[field.key]) }} <br/>
            </div>

            <div v-else-if="field.key==='totalDist'">{{ insertComma(item[field.key]) }}</div>
            <div v-else-if="field.key==='type'">{{ typeMap[item[field.key]] }}</div>

            <div v-else-if="field.key==='driverId'">{{ item[field.key].substr(0, 4) !== '9999' ? item[field.key] : '임시자격번호' }}</div>

            <div v-else>{{ item[field.key] }}</div>
          </td>
          <td>
            <div class="icon-box d-flex justify-content-between">
              <BIconPencilSquare class="icon" @click="$emit('open-modal',item,'modify')"/> 
              <BIconTrash class="icon" @click="$emit('delete',type === 'addVehicle' ?  item.vehicleId : item.appmeterId || item.officeId || item.employeeId)"/>
            </div>
          </td>
        </tr>
        <td v-if="items.length === 0" :colspan=fields.length+1 class="remaining-box" >
          <span class="remaining-text">데이터가 없습니다.</span>
        </td>
      </tbody>
    </v-table>
  </div>
</template>

<script setup>
import { defineProps, ref } from "vue";
import { dateFormatFunc,insertComma } from "@/components/tacho/common/CommonFunc";
import {BIconPencilSquare, BIconTrash} from "bootstrap-icons-vue";

const emit = defineEmits(['update','delete','open-modal'])
const props = defineProps({
  fields: Object,
  items: Object,
  numOfTotal: Number,
  loadMore: Function,
  height: String,
  type: String,
  customHeight: String,
  regionList: Object
})

const scroll = ref("");
const table = ref(null);

const typeMap = {"NORMAL": "법인", "INDIVIDUAL": "개인"};
</script>

<style scoped>
.table-container {
  font-size: 0.8rem;
  border-bottom: 1px solid #c9c8c8;
  border-top: 1px solid #c9c8c8;
}
 th {
  text-align: center !important;
}

 td {
  table-layout: fixed;
}
.v-table.v-table--fixed-header > .v-table__wrapper > table > thead > tr > th {
  background: #e3e3e3 !important;
}
.v-table .v-table__wrapper > table > thead > tr > th {
  color: black;
}
.icon-box{
  width: 3.5rem;
  font-size: 1.5rem;
}
.icon{
  cursor:pointer
}
.remaining-box {
  height: 40px;
}
.remaining-text {

  color: black;
}
</style>